<!-- Custom modal setup -->
<div id="modal-container" class="hidden"></div>
<div id="modal-overlay" class="hidden"></div>
